import { FormControl, FormGroup } from '@angular/forms';
import { ValidatorInterface } from '@vendasta/ai-assistants';
import { FormArrayWithDirtyTracking } from './forms';

export type ValidatorFormControls = {
  validator: FormControl<ValidatorInterface | null>;
};

export class ValidatorForm extends FormGroup<ValidatorFormControls> {
  constructor(validator?: ValidatorInterface) {
    super({
      validator: new FormControl(validator ?? null),
    });
  }

  toValidator(): ValidatorInterface | undefined {
    return this.controls.validator.getRawValue() ?? undefined;
  }
}

export class AiValidatorsFormArray extends FormArrayWithDirtyTracking<ValidatorForm> {
  constructor(validators?: ValidatorInterface[]) {
    super((validators ?? []).map((validator) => new ValidatorForm(validator)));
  }

  toValidators(): ValidatorInterface[] {
    return this.controls.map((form) => form.toValidator()).filter((v): v is ValidatorInterface => v !== undefined);
  }
}
